import { atom } from 'jotai';
import { PROJECT_STATUS } from '../lib/constants';
import { Project } from '../types';

interface State {
  isOpen: boolean;
  project?: Project;
  status?: typeof PROJECT_STATUS[keyof typeof PROJECT_STATUS];
}

export const changeProjectStatusConfirmDialogAtom = atom<State>({
  isOpen: false,
  project: undefined,
});
